import React from "react";
import { CurrentAddress, UserProfileType } from "../../../redux/auth/authTypes";
import Select from "react-select";
type profileDetailsErrorType = {
  nameError: string;
  emailError: string;
  newPasswordError: string;
  newPasswordAgainError: string;
  countryError: string;
  stateError: string;
  cityError: string;
};
type AppProps = {
  data: CurrentAddress;
  setProfileForm: React.Dispatch<React.SetStateAction<UserProfileType>>;
  handleAddressDetails: (data: any) => void;

  Option: any;
  countrySelectedList: any;
  countryFetching: boolean;
  setCountryText: React.Dispatch<React.SetStateAction<string>>;
  setCountryOffset: React.Dispatch<React.SetStateAction<number>>;
  countrylimit: number;
  finalCountry: any;
  handleChangeCountry: (data: any) => void;
  handleChangeState: (data: any) => void;
  finalStateList: any;
  stateFetching: boolean;
  setStateText: React.Dispatch<React.SetStateAction<string>>;
  setStateOffset: React.Dispatch<React.SetStateAction<number>>;
  finalCityList: any;
  handleChangeCity: (data: any) => void;
  setCityOffset: React.Dispatch<React.SetStateAction<number>>;
  setCityText: React.Dispatch<React.SetStateAction<string>>;
  profileDetailsError: profileDetailsErrorType;
  isState: boolean | null;
  isCity: boolean | null;
};

const LoggedInuserPersonalAddress = ({
  data,
  setProfileForm,
  handleAddressDetails,
  Option,
  countrySelectedList,
  countryFetching,
  setCountryText,
  setCountryOffset,
  countrylimit,
  finalCountry,
  handleChangeCountry,
  handleChangeState,
  finalStateList,
  stateFetching,
  setStateText,
  setStateOffset,
  finalCityList,
  handleChangeCity,
  setCityOffset,
  setCityText,
  profileDetailsError,
  isState,
  isCity
}: AppProps) => {
  const checkBottom = (e: any) => {
    setCountryOffset((prv: any) => prv + countrylimit);
  };
  const checkBottomState = (e: any) => {
    setStateOffset((prv: any) => prv + countrylimit);
  };
  const checkBottomCity = (e: any) => {
    setCityOffset((prv: any) => prv + countrylimit);
  };
  return (
    <div className="form-group">
      <h6>CURRENT ADDRESS</h6>

      <div className="row mt-2">
        <div className="col-md-6">
          <label htmlFor="addressLine1">Address Line 1</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="address_line1"
              onChange={handleAddressDetails}
              value={data?.address_line1 || ""}
            />
          </div>
        </div>
        <div className="col-md-6">
          <label htmlFor="addressLine2">Address Line 2</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="address_line2"
              onChange={handleAddressDetails}
              value={data?.address_line2 || ""}
            />
          </div>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-md-3">
          <label htmlFor="postal_code">Postal Code</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="postal_code"
              //   disabled={!isEdit}
              onChange={handleAddressDetails}
              value={data?.postal_code || ""}
            />
          </div>
        </div>
        <div className="col-md-3">
          <label htmlFor="country">
            Country <span className="color-red">*</span>
          </label>
          <Select<any, false>
            components={{ Option }}
            isSearchable={true}
            inputProps={{ autoComplete: "nope" }}
            placeholder={"Select country"}
            isLoading={countryFetching}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            options={countrySelectedList}
            onChange={(e: any) => {
              if (e) {
                setProfileForm((prv: UserProfileType) => {
                  return {
                    ...prv,
                    user_details: {
                      ...prv.user_details,
                      current_address: {
                        ...prv.user_details.current_address,
                        country: {
                          label: e?.label,
                          value: e?.value,
                        },
                        state: {
                          label: "Select",
                          value: null,
                        },
                        city: {
                          label: "Select",
                          value: null,
                        },
                      },
                    },
                  };
                });
              }
              handleChangeCountry(e);
            }}
            value={data?.country}
            onInputChange={(e) => {
              setCountryText(e);
              setCountryOffset(0);
            }}
          />
        </div>
        {data?.country?.value && isState && (
          <div className="col-md-3">
            {isState && (
              <label htmlFor="state">
                State <span className="color-red">*</span>
              </label>
            )}
            {isState && (
              <Select<any, false>
                inputProps={{ autoComplete: "nope" }}
                components={{ Option }}
                isSearchable={true}
                placeholder={"Select state"}
                options={finalStateList}
                isLoading={stateFetching}
                onMenuScrollToBottom={(e: any) => checkBottomState(e)}
                // value={selectBranch}

                onChange={(e: any) => {
                  if (e) {
                    setProfileForm((prv: UserProfileType) => {
                      return {
                        ...prv,
                        user_details: {
                          ...prv.user_details,
                          current_address: {
                            ...prv.user_details.current_address,
                            // ...prv,user_details.personal_details,
                            state: {
                              label: e?.label,
                              value: e?.value,
                            },
                            city: {
                              label: "Select",
                              value: null,
                            },
                          },
                        },
                      };
                    });
                  }
                  handleChangeState(e);
                }}
                value={data?.state}
                onInputChange={(e) => {
                  setStateText(e);
                  setStateOffset(0);
                }}
              />
            )}
            {!!profileDetailsError?.stateError && (
              <small className="text-danger">
                {profileDetailsError?.stateError}
              </small>
            )}
          </div>
        )}
        {((isState === true && data?.state?.value && isCity) ||
          (isState === false && data?.country?.value && isCity)) && (
            <div className="col-md-3">
              <form>
                <div>
                  <div>
                    <label htmlFor="City" className={"active"}>
                      City <span className='color-red'>*</span>
                    </label>

                    <Select
                      components={{ Option }}
                      isSearchable={true}
                      options={finalCityList}
                      isLoading={countryFetching}
                      value={
                        data?.city
                      }
                      onMenuScrollToBottom={(e: any) => checkBottomCity(e)}
                      onChange={(e: any) => {
                        if (e) {
                          setProfileForm((prv: UserProfileType) => {
                            return {
                              ...prv,
                              user_details: {
                                ...prv.user_details,
                                current_address: {
                                  ...prv.user_details.current_address,
                                  // ...prv,user_details.personal_details,
                                  city: {
                                    label: e?.label,
                                    value: e?.value,
                                  },
                                },
                              },
                            };
                          });
                        }
                        handleChangeCity(e);
                      }}
                      onInputChange={(e) => {
                        setCityText(e);
                        setCityOffset(0);
                      }}
                    />
                  </div>
                </div>
              </form>
              {!!profileDetailsError?.cityError && (
                <small className="text-danger">
                  {profileDetailsError?.cityError}
                </small>
              )}
            </div>
          )}
      </div>
      {/* ////// */}
    </div>
  );
};

export default LoggedInuserPersonalAddress;
